var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { id: "cardDiv" } },
    [
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirm,
          titulo: "Asociar Gps",
          mensaje:
            "¿Está seguro que desea asociar el gps al cliente " +
            _vm.clientSelected.nombre +
            " ?",
          textoBtnSi: "Guardar asociación",
          textoBtnNo: "Cancelar"
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackSave($event)
          }
        }
      }),
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Asociar Gps" },
          on: { cerrar: _vm.handleCLoseModal }
        },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-continuar",
              attrs: { disabled: !_vm.haveChanges },
              on: { click: _vm.handleBtnSave }
            },
            [_vm._v("\n      Guardar\n    ")]
          )
        ],
        1
      ),
      _c("div", { staticStyle: { width: "100%", "margin-top": "64px" } }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "100%",
              padding: "20px 20px 0px 20px",
              "margin-left": "20px"
            }
          },
          [
            _c(
              "h3",
              { staticStyle: { "font-weight": "100", "margin-bottom": "7px" } },
              [_vm._v("Gps seleccionados:")]
            ),
            _c("table", [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Id")]),
                  _c("th", [_vm._v("Imei")]),
                  _c("th", [_vm._v("Número de serie")]),
                  _c("th", [_vm._v("Patente")]),
                  _c("th", [_vm._v("Referencia")])
                ])
              ]),
              _c(
                "tbody",
                _vm._l(_vm.gps, function(gps) {
                  return _c("tr", { key: gps.id }, [
                    _c("td", [_vm._v(_vm._s(gps.id))]),
                    _c("td", [_vm._v(_vm._s(gps.imei))]),
                    _c("td", [_vm._v(_vm._s(gps.numeroserie))]),
                    _c("td", [_vm._v(_vm._s(gps.patente))]),
                    _c("td", [_vm._v(_vm._s(gps.referencia))])
                  ])
                }),
                0
              )
            ])
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              width: "100%",
              "margin-top": "0px",
              padding: "0px 20px 20px 20px"
            }
          },
          [
            _c(
              "fieldset",
              { attrs: { id: "FSStyle" } },
              [
                _c(
                  "legend",
                  {
                    staticStyle: {
                      "margin-left": "0.3rem",
                      color: "#9e9e9e",
                      "font-size": "1rem"
                    }
                  },
                  [_vm._v("\n          Asociar Cliente:\n        ")]
                ),
                _c("div", { attrs: { id: "TFDiv" } }, [
                  _c(
                    "div",
                    { staticStyle: { width: "50vw" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Buscar...",
                          "single-line": "",
                          "hide-details": ""
                        },
                        on: { input: _vm.handleSearchClient },
                        model: {
                          value: _vm.searchClientTF,
                          callback: function($$v) {
                            _vm.searchClientTF = $$v
                          },
                          expression: "searchClientTF"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("v-card", { staticStyle: { margin: "20px" } }, [
                  _c("div", { attrs: { id: "bodyDiv" } }, [
                    _c(
                      "div",
                      { staticClass: "gridcard rounded-card" },
                      [
                        _c("AgGridVue", {
                          ref: "gridComponent",
                          staticClass: "ag-theme-material",
                          attrs: {
                            id: "gridComponent",
                            gridOptions: _vm.gridOptions
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }